/**
 * 安卓浏览器（Chrome / 夸克等）在「页面本身不能横滑」时，
 * 任意左右滑都会被当成历史记录前进/后退，不必滑到尽头。
 * 在窄屏上拦截这类手势；表格等需要横滑的区域放行。
 */

const MOBILE_MQ = '(max-width: 1024px), (pointer: coarse)'
const ALLOW_SWIPE_SELECTOR = [
  '.table-container',
  '.el-table__body-wrapper',
  '.el-scrollbar__wrap',
  '.scroll-container.is-native',
  '.el-dialog__body',
  '.el-tabs__nav-scroll',
  '.el-carousel',
  '.el-slider',
  '[data-allow-h-swipe]'
].join(',')

let startX = 0
let startY = 0
let allowHorizontal = false
let installed = false

function isMobile() {
  return typeof window !== 'undefined' &&
    window.matchMedia &&
    window.matchMedia(MOBILE_MQ).matches
}

function onTouchStart(e) {
  if (!isMobile() || !e.touches || e.touches.length !== 1) return
  const t = e.touches[0]
  startX = t.clientX
  startY = t.clientY
  const el = e.target
  allowHorizontal = !!(el && el.closest && el.closest(ALLOW_SWIPE_SELECTOR))
}

function onTouchMove(e) {
  if (!isMobile() || allowHorizontal || !e.touches || e.touches.length !== 1) return
  const t = e.touches[0]
  const dx = t.clientX - startX
  const dy = t.clientY - startY
  // 横向占主导：阻止浏览器历史翻页手势
  if (Math.abs(dx) > 12 && Math.abs(dx) > Math.abs(dy) * 1.2) {
    e.preventDefault()
  }
}

export function installBlockSwipeNavigation() {
  if (installed || typeof document === 'undefined') return
  installed = true
  document.addEventListener('touchstart', onTouchStart, { passive: true, capture: true })
  document.addEventListener('touchmove', onTouchMove, { passive: false, capture: true })
}



// WEBPACK FOOTER //
// ./src/utils/blockSwipeNavigation.js